import Image from "next/image";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import styles from "./AdvantageBlock.module.scss";
import { Advantage, AdvantageProps } from "./advantage/Advantage";

export type AdvantageBlockProps = {
  title: string;
  image: StrapiEntity<StrapiImage>;
  advantages: AdvantageProps[];
};

export const AdvantageBlock = ({
  title,
  image,
  advantages,
}: AdvantageBlockProps) => {
  const strapiImage = formatStrapiEntity(image);

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.content}>
          <div className={styles.imageContainer}>
            <Image
              src={addBasePathToStrapiMedia(strapiImage)}
              objectFit="contain"
              objectPosition="center"
              alt={strapiImage.alternativeText ?? ""}
              layout="fill"
            />
          </div>
          <div className={styles.advantages}>
            {advantages.map((advantage, index) => (
              <Advantage {...advantage} key={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
